import { forwardRef } from "react";

import { cn } from "../index";

export type CardProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Card = forwardRef<HTMLDivElement, CardProps>(({ children, className, onClick, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={cn("p-5 h-fit w-fit rounded-[10px] bg-primary-white", className)}
    onClick={onClick}
  >
    {children}
  </div>
));
